import { cancelToken, get, getQueryParams } from '@fareye/utils'
import React, { useEffect, useState } from 'react'
import {
  HEADER_INFLECTION,
  initialState,
  POI_COLUMNS,
  POI_CONFIG
} from '../../../config/constants'
import { Button, Flex, RenderControl, Table } from '@fareye/ui'
import { getTableColumns } from '../components/Column'
import { useTranslation } from '@fareye/common'
import PoiModal from '../components/PoiModal'
import PoiUpload from '../components/PoiUpload'

export default function PoiConfig({ match }: any) {
  const { params: { userId } } = match
  const source = cancelToken().source()
  const { poiConfig } = POI_CONFIG
  const { t } = useTranslation()

  const [poiData, setPoiData] = useState<any>({
    ...initialState,
    data: [],
    isLoading: false,
    meta: { totalElements: 0 }
  })

  const [pageNo, setPageNo] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(100)

  const [selectedPoi, setSelectedPoi] = useState({
    data: {},
    action: 'add',
    openModal: false
  })

  useEffect(() => {
    if (userId) {
      fetchPoiData()
    }
  }, [userId, pageNo, recordsPerPage])

  async function fetchPoiData() {
    try {
      setPoiData((prev: any) => ({ ...prev, isLoading: true })) 
      const queryParam = getQueryParams({ 
        userId, 
        pageNo: pageNo + 1, // API usually wants 1-based
        recordsPerPage: recordsPerPage 
      })
      const { data: { content, meta } }: any = await get(
        `${poiConfig}?${queryParam}`, 
        source.token, 
        HEADER_INFLECTION
      )
      const tempData = [...poiData.data]
      tempData.splice(pageNo * recordsPerPage, recordsPerPage, ...content)
      setPoiData({
        ...poiData,
        data: tempData,
        meta: meta,
        isLoading: false,
        isError: false,
      })
    } catch (error) {
      setPoiData((prev: any) => ({ ...prev, isLoading: false, isError: true }))
    }
  }

  return (
    <Flex style={{ padding: '20px' }} column>
      <Flex alignItemsCenter justifyContentSpaceBetween>
        <h3>Poi Config for User - {userId}</h3>
        <Flex>
          <Button variant="primary" mr={4} onClick={() => setSelectedPoi({ data: { userId }, action: 'add', openModal: true })}>
            Add Poi
          </Button>
          <PoiUpload userId={userId} />
        </Flex>
      </Flex>

      <RenderControl state={poiData}>
        <Table
          className="striped responsive"
          columns={getTableColumns(POI_COLUMNS, { t, setSelectedPoi })}
          data={poiData.data}
          size="xs"
          sortable        
          showPagination={true}          
          totalElements={poiData.meta?.totalElements || 0}
          defaultPageSize={recordsPerPage}
          defaultPageIndex={pageNo} 
          onPageChange={(pageIndex: number) => {
            setPageNo(pageIndex)
          }}
          onPageSizeChange={(pageSize: number) => {
            setPageNo(0)
            setRecordsPerPage(pageSize)
            setPoiData((prev: any) => ({ ...prev, data: [] }))
          }}
          dataLoading={poiData.isLoading}
        />
      </RenderControl>    
      <PoiModal selectedPoi={selectedPoi} setSelectedPoi={setSelectedPoi} />
    </Flex>
  )
}
